import React from 'react';
import { WifiOff } from 'lucide-react';
import { useOnlineStatus } from '../hooks/useOnlineStatus';
import { Badge } from '@/components/ui/badge';
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from '@/components/ui/tooltip';
import { useTranslation } from 'react-i18next';

/**
 * OfflineStatusBadge - A minimal, elegant indicator for the header
 *
 * Shows:
 * - Nothing when online
 * - Subtle badge when offline
 */
const OfflineStatusBadge: React.FC = () => {
    const isOnline = useOnlineStatus();
    const { t } = useTranslation();

    // Hide when online
    if (isOnline) {
        return null;
    }

    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <Badge
                        variant="secondary"
                        className="bg-blue-100 text-blue-800 border-blue-300 px-2 py-1 gap-1.5 text-xs font-medium"
                    >
                        <WifiOff className="h-3 w-3" />
                        <span>{t('offline.title', { defaultValue: 'Offline' })}</span>
                    </Badge>
                </TooltipTrigger>
                <TooltipContent side="bottom" className="max-w-xs">
                    <p className="text-sm">{t('offline.message', { defaultValue: 'You are currently offline' })}</p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
};

export default OfflineStatusBadge;
